"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.JOBS, (table)=>{
        table.string('id', 20).primary();
        table.string('job', 255);
        table.string('status', 20);
        table.text('result');
        table.string('fk_user_id', 20);
        table.string('fk_workspace_id', 20);
        table.string('base_id', 20);
        table.timestamps(true, true);
    // TODO - add indexes
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.JOBS);
};
